module.exports = __webpack_public_path__ + "media/images/icons/orange_arrow-31346fa80b305f6275c0086152dffddd.svg";